export default __webpack_public_path__ + "3d0355e.png";